module.exports = __webpack_public_path__ + "assets/img/managingagent.917bba89.svg";